module.exports = __webpack_public_path__ + "img/thumb_18.08b2daff.jpg";